import type { ReactElement } from "react"
import type { VideoAtmProps } from "@onestore/hel/dist/components/atoms/VideoAtm"
import VideoAtm from "@onestore/hel/dist/components/atoms/VideoAtm"
import type { ImageProps } from "@ionos-web-design-system/react"
import { Picture } from "@ionos-web-design-system/react"
import type { EmbeddedAssetSquidexMetadata } from "~/fragments/image"
import assetsSquidexToImageObject from "~/lib/assetsSquidexToImageObject"
import assetsSquidexToVideoObject from "~/lib/assetsSquidexToVideoObject"
import type { FetchPriority } from "~/types/mediaTypes"
import type { ResponsiveImages } from "~/types/squidex"
import ResponsiveMedia from "../ResponsiveMedia"

type MediaProps = {
  media: ResponsiveImages | EmbeddedAssetSquidexMetadata[]
  fetchPriority?: FetchPriority
  className?: string
  maxWidth?: number
  maxHeight?: number
}

enum FileType {
  MP4 = "mp4",
}

function Media({
  media,
  fetchPriority,
  className,
  maxWidth,
  maxHeight,
}: MediaProps): ReactElement<ImageProps | VideoAtmProps> {
  if (!Array.isArray(media)) {
    return (
      <ResponsiveMedia
        media={media}
        fetchPriority={fetchPriority}
        className={className}
      />
    )
  } else {
    const videoAssets = media.filter((asset) => asset.fileType === FileType.MP4)

    if (videoAssets.length > 0) {
      return (
        <VideoAtm
          video={assetsSquidexToVideoObject(videoAssets)}
          isLooped
          isAutoPlayed
          isMuted
          disablePictureInPicture
        />
      )
    }

    return (
      <Picture
        srcData={assetsSquidexToImageObject(media, "")}
        className={className}
        style={maxWidth || maxHeight ? { maxWidth, maxHeight } : undefined}
        {...(fetchPriority ? { fetchpriority: fetchPriority } : {})}
      />
    )
  }
}

export default Media
